"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.pillThemes = exports.pillTypes = exports.paddingSizes = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.tagging-utils");

var _gerenciatdReact = _interopRequireDefault(require("@bit/gerenciatd.react.link-over-box"));

var _gerenciatdReact2 = _interopRequireDefault(require("@bit/gerenciatd.react.icon"));

require("./Pill.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var paddingSizes = {
  SIMPLE: 'simple',
  REDUCED: 'reduced'
};
exports.paddingSizes = paddingSizes;
var pillTypes = {
  SOFT: 'Soft',
  SOLID: 'Solid'
};
exports.pillTypes = pillTypes;
var pillThemes = {
  GREEN: 'Green',
  GREEN1: 'Green1',
  GREENTRANSPARENT: 'GreenTransparent',
  BLUE: 'Blue',
  BLUE2: 'Blue2',
  BLUETRANSPARENT: 'BlueTransparent',
  RED: 'Red',
  WHITE: 'White',
  MUSTARD: 'Mustard',
  BLUEGREY: 'BlueGrey',
  BLACK: 'Black'
};
/**
 * Stateless component to draw an Pill
 * @param {string} label Span of the pill.
 * @param {string} theme Theme color
 * @param {string} type Type color
 * @param {bool} active determine if that pill is active or not
 * @param {boolean} loading show loader instead of icon
 * @param {string} classIcon Icon to show. If undefined, no icon is shown.
 * @param {boolean} badge True: shows badge, False: hides badge.
 * @param {func} onClick Executed function by clicking the pill.
 * @param {boolean} disabled Disables the pill by changing its css.
 * @param {string} taggingType type of button tagging.
 * @param {string} id Button id, used for tagging.
 * @param {string} managementValue Value for management tagging
 * @param {bool} canBeUnselected true if can be unselected, false otherwise
 * @returns {JSX} Component JSX.
 */

exports.pillThemes = pillThemes;

var Pill =
/*#__PURE__*/
function (_Component) {
  _inherits(Pill, _Component);

  function Pill() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Pill);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pill)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (evt) {
      var code = evt.keyCode || evt.which;

      if (code === 13) {
        _this.handleClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlerClick", function () {
      var _this$props = _this.props,
          taggingType = _this$props.taggingType,
          id = _this$props.id,
          managementValue = _this$props.managementValue,
          onClick = _this$props.onClick,
          active = _this$props.active,
          canBeUnselected = _this$props.canBeUnselected;

      if (taggingType && id && (0, _gerenciatdUtils.detectCorrectButtonType)(taggingType)) {
        (0, _gerenciatdUtils.sendButtonTagging)(taggingType, id);
      }

      if (managementValue && id) {
        (0, _gerenciatdUtils.sendManagementTagging)(managementValue, id);
      }

      if (onClick && (!active || canBeUnselected)) {
        _this.props.onClick(id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "determinePillActivity", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          active = _this$props2.active,
          canBeUnselected = _this$props2.canBeUnselected;
      var returnType = type;

      if (active) {
        returnType = "".concat(returnType, " active");

        if (canBeUnselected) {
          returnType = "".concat(returnType, " canBeUnselected");
        }
      }

      return returnType;
    });

    return _this;
  }

  _createClass(Pill, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          label = _this$props3.label,
          theme = _this$props3.theme,
          classIcon = _this$props3.classIcon,
          loading = _this$props3.loading,
          disabled = _this$props3.disabled,
          link = _this$props3.link,
          paddingSize = _this$props3.paddingSize,
          dopped = _this$props3.dopped;
      /* Sets a CSS class if contains an Icon */

      var withIcon = classIcon ? 'pill-with-icon' : '';
      var realType = this.determinePillActivity();
      var doppedClass = dopped ? 'dopped' : '';
      return _react.default.createElement("div", {
        className: "pill ".concat(doppedClass, " ").concat(paddingSize, " ").concat(withIcon, " type").concat(realType, " theme").concat(theme).concat(loading ? ' loading' : '').concat(disabled ? ' disabled' : ''),
        role: "button",
        tabIndex: "-1",
        onClick: this.handlerClick,
        onKeyPress: this.handleKeyPress
      }, _react.default.createElement(_react.Fragment, null, link && _react.default.createElement(_gerenciatdReact.default, {
        link: link,
        alt: label
      }), !classIcon && _react.default.createElement("span", {
        className: "label"
      }, label), classIcon && !loading && _react.default.createElement(_gerenciatdReact2.default, {
        wrapperClass: "pill-icon",
        label: label,
        title: label,
        classIcon: classIcon
      }), loading && _react.default.createElement(_reactLoaderSpinner.default, {
        type: "TailSpin",
        color: realType === 'Solid' ? 'white' : '#989a9e',
        height: 20,
        width: 20
      })));
    }
  }]);

  return Pill;
}(_react.Component);

Pill.propTypes = {
  label: _propTypes.default.string.isRequired,
  theme: _propTypes.default.string,
  type: _propTypes.default.string,
  loading: _propTypes.default.bool,
  classIcon: _propTypes.default.string,
  onClick: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  badge: _propTypes.default.bool,
  taggingType: _propTypes.default.string,
  managementValue: _propTypes.default.string,
  id: _propTypes.default.string,
  active: _propTypes.default.bool,
  paddingSize: _propTypes.default.string,
  dopped: _propTypes.default.bool,
  canBeUnselected: _propTypes.default.bool
};
Pill.defaultProps = {
  theme: pillThemes.BLUE,
  type: pillTypes.SOFT,
  classIcon: '',
  loading: false,
  onClick: null,
  badge: false,
  taggingType: '',
  managementValue: '',
  id: '',
  active: false,
  paddingSize: paddingSizes.SIMPLE,
  dopped: false,
  canBeUnselected: false
};
var _default = Pill;
exports.default = _default;

//# sourceMappingURL=index.js.map